var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicycleColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M98.48 98.57l-26.14-5.68l.37-1.74l26.24 5.48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M72 108.31l-.25-1.73l28.15-5.79l.41 1.96z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.37 91.11c-5.28-.25-9.15 5.17-8.71 9.54c.46 4.54 3.78 7.88 8.89 7.78c4.82-.09 8.15-3.43 8.24-8.52s-2.59-8.52-8.42-8.8zm2.5 12.79c-2.32 1.2-5.15.42-6.48-2.04c-1.2-2.22.18-5.59 2.59-6.39c2.22-.74 4.48.19 5.65 2.04c1.29 2.03.74 5.09-1.76 6.39z",
    fill: "#858587"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M101.092 96.469l3.797-16.95l.976.219l-3.797 16.95z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M101.39 98.43l11.75-14.76l.78.62l-9.18 11.55l13.77-6.19l.41.91z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M119.78 106.84l-18.2-6.97l19.08-3.1l.16.99l-15.42 2.5l14.73 5.65z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M99.4 96l-3.04-16.43l.99-.15l3.04 16.43z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M86.127 85.228l.758-.654l11.06 12.818l-.757.653z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.18 113.54l-.6-.8l.3.4l-.32-.38c.39-.35 9.5-9.63 12.98-13.17l.71.7c-3.84 3.91-12.81 13.05-13.07 13.25z",
    fill: "#b9baba"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M98.374 102.021l.991-.136l2.537 18.548l-.991.136z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M92.8 119.43l-.87-.48l9.19-16.84l14.78 11.09l-.6.8l-13.86-10.39z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M102.57 101.49l.932-.362l6.64 17.053l-.933.363z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.66,
    cy: 99.48,
    rx: 4.08,
    ry: 3.96,
    fill: "#c9c8c8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.17 75.1c-13.87.15-24.01 10.51-24.41 24.18c-.39 13.1 10 24.52 23.87 24.96c14.82.47 25.75-11.01 25.43-24.69c-.32-13.3-10.69-24.61-24.89-24.45zm-.51 45.46c-11.89-.38-20.8-10.16-20.46-21.4c.35-11.72 9.04-20.6 20.93-20.73c12.17-.13 21.06 9.56 21.33 20.96c.27 11.73-9.09 21.57-21.8 21.17z",
    fill: "#484d50"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.28 77.9c-12.29.14-21.27 9.31-21.63 21.41c-.35 11.6 8.86 21.71 21.14 22.1c13.13.41 22.81-9.75 22.52-21.86c-.27-11.77-9.46-21.78-22.03-21.65zm-.57 41.7c-11.26-.35-19.25-9.6-18.93-20.14c.33-11 8-19.05 19.27-19.17c11.53-.13 20.36 8.97 20.21 19.68c-.16 10.65-8.51 20.01-20.55 19.63z",
    fill: "#c9c9c9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M23.934 120.375l4.303-19.738l1.075.235l-4.303 19.737z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M29.052 99.098l17.476-6.71l.394 1.026l-17.475 6.711z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M41.2 115.01L28.02 98.58l-4.76-19.09l1.07-.26l4.7 18.85l13.03 16.24z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M27.01 98.57l-.95-.43l6.24-18.33l1.05.33z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M27.82 98.814l14.485-13.586l.753.802l-14.486 13.586z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M9.315 88.774l.543-.957l16.5 9.382l-.544.956z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M17.04 117.82l-.98-.48l8.51-17.26l-18.02-4.21l.25-1.07l19.37 4.52z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M6.83 105.25l-.3-1.06l19.43-5.53l-10.16-16.2l.93-.59l10.94 17.44z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M10.78 113.27l-.6-.93l16.95-10.96l19.4 4.83l-.26 1.06l-18.94-4.71z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M25.751 102.025l1.01-.436l7.686 17.802l-1.01.436z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9baba",
    d: "M30.49 98.467l.114-1.094l17.149 1.78l-.114 1.093z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.26 75.17c-13.87.15-24 10.51-24.41 24.18c-.39 13.1 10 24.52 23.87 24.96c14.82.47 25.75-11.01 25.43-24.69c-.31-13.3-10.69-24.61-24.89-24.45zm-.51 45.46c-11.89-.38-20.8-10.16-20.46-21.4c.35-11.72 9.04-20.6 20.93-20.73c12.17-.13 21.06 9.56 21.33 20.96c.28 11.73-9.09 21.57-21.8 21.17z",
    fill: "#484d50"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.37 77.97c-12.29.14-21.26 9.31-21.62 21.42c-.35 11.6 8.86 21.71 21.14 22.1c13.13.41 22.81-9.75 22.52-21.86c-.28-11.78-9.46-21.79-22.04-21.66zm-.56 41.7c-11.26-.35-19.25-9.6-18.93-20.14c.33-11 8-19.05 19.27-19.17c11.53-.13 20.36 8.97 20.21 19.68c-.17 10.65-8.52 20.01-20.55 19.63z",
    fill: "#c9c9c9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1 53.21s1.43-3.36 1.49-4.18c.06-.83-.24-1.77-1.62-1.82c-1.38-.06-4.23-.16-4.23-.16l-2.8-5.6l-1.92-3.04s-1.43-.5-2.37.33s-1.16 1.76-.5 3.03s3.96 8.26 4.73 8.48c.77.22 3.96.06 4.18.17c.22.11-.99 2.53-.99 2.53l4.03.26z",
    fill: "#c9c9c9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M90.15 55.08l-4.82 2.96l-3.5-2s-1.76-1.36-3.04-1.83c-1.57-.58-3.72-.29-4.76-1.78c-.81-1.15 14.35-1.59 14.35-1.59l1.77 4.24z",
    fill: "#b3b3b3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.55 48.89c-2.59.18-3.75.27-4.02 1.34c-.29 1.15 1.95 2.78 2.92 3.25c1.01.49 5.9-.98 6.6-.83c2.04.44 5.12 3.08 6.71 3.14c1.6.06 6.34-3.68 6.77-4.02c.77-.61 1.05-2.75-1.38-2.97c-2.41-.21-15.56-.05-17.6.09z",
    fill: "#5e6268"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.36 37.43c-1.41.08-1.14 2.89-.67 3.67c.66 1.1 1.6 1.98 3.25 2.04c1.65.06 15.41-.72 16.46-.88c1.05-.17 1.04-1.58.65-3.03c-.25-.91-1.09-2.51-2.13-2.59c-1.48-.11-15.95.7-17.56.79z",
    fill: "#5e6268"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.26 97.73l-16.79-33.9l1.1-5.89l-4.67-.44s-.84 4.53-1.06 4.69c-.22.17-33.01-.56-33.01-.56l1.73-5.85l-4.81-.59c-.5 1.54-9.14 31.43-11.23 35.11c-2.09 3.69-4.35 7.08-4.35 7.08s-.89-.46-1.91-.1c-.79.28-2.17 1.23-1.76 3.21c.33 1.6 2.1 2.59 3.55 2.1c2.2-.75 1.98-2.83 1.98-2.83s5.21-4.97 7.01-7.92c1.78-2.93 5.7-17.05 5.8-17.04c.38.04 25.89 28.15 26.73 28.42c.66.22 30.66-2.04 30.66-2.04l1.71-1.32l-.68-2.13zm-32.28-2.26S44.43 69.63 44.6 69.12c.02-.06.62-2.24.69-2.34c.2-.29 32.86.74 32.86.74l-9.17 27.95zm3.88 3.25L82.38 69L97.3 97.62l-24.44 1.1z",
    fill: "#67a6ad"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.02 98.22c-.26.04-1.62 1.38-1.59 1.93c.02.56 1.47 1.59 1.91 1.62c.43.02 1.62-1.5 1.62-1.86c-.01-.36-1.61-1.74-1.94-1.69z",
    fill: "#626168"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M100.12 97.56c-.28.16-1.2 1.46-1.23 1.85c-.03.39.66 1.85.9 1.94c.24.09 1.61.12 1.97.03s1.2-1.4 1.2-1.76s-.51-1.46-.72-1.73s-1.91-.45-2.12-.33z",
    fill: "#626168"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.79 55.94c-.35.29-.79 2.88.05 2.93s5.7.16 6.02 0s.37-2.41.1-2.72s-5.86-.48-6.17-.21z",
    fill: "#c9c9c9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.31 51.91c-.58.21-1.78 3.82-1.52 4.24c.26.42 7.64 1.26 8.01 1.2c.37-.05 1.31-4.08 1.05-4.4s-7.01-1.24-7.54-1.04z",
    fill: "#b3b3b3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.92 106.6s6.78-6.64 7.56-7.36c.64-.59 1.28-1.42 2.43-1.28c1.15.14 1.49.88 1.49.88l-1.26 3.11l-7.65 6.54l-.95 3.98l-6.85-1.58s-.01-2.3 0-2.87c.01-.63-.13-1.31 1.32-1.31s3.91-.11 3.91-.11z",
    fill: "#b3b3b3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.36 108.1c-.16.24-.04 2.19-.16 2.54c-.12.36-1.9.2-2.83.24c-1.13.05-3.68 0-3.68 0s0 1.62.04 1.98s.32.93 1.54.93s5.22-.16 5.87-.2s1.34-.59 1.33-1.7c-.01-.85.01-2.57.01-2.57s6.75-6.49 7.48-7.13c.73-.65 1.19-1.01 1.13-1.98c-.04-.65-.68-1.37-.68-1.37l-10.05 9.26z",
    fill: "#858587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycleColor);
export default __webpack_public_path__ + "static/media/bicycle_color.fcbb5459e688affae957eac6c8890caa.svg";
export { ForwardRef as ReactComponent };